<common-ui-components-page-layout
  [stickyHeader]="true"
  title="درباره ما"
>
  <div class="d-flex flex-column align-items-center p-plus">
    <img
      src="assets/about-us.png"
      class="about-us-image"
      alt="about digipay"
    />

    <div class="d-flex gap-big my-giant">
      @for (item of socialLinks; track item.icon) {
        @if (item.icon) {
          <a
            [href]="item.link"
            target="_blank"
            class="text-decoration-none"
          >
            <div class="surface-back d-flex justify-content-center align-items-center radius-minus icon-container">
              <common-icon-dp-icon
                [icon]="item.icon"
                [classes]="'text-onback-high'"
              ></common-icon-dp-icon>
            </div>
          </a>
        }
      }
    </div>

    <span class="text-onback-high bt-2">محصولی از شرکت نوآوران پرداخت مجازی ایرانیان </span>
    <span class="text-onback-low bt-2">تاسیس: ۱۳۹۷</span>
  </div>
</common-ui-components-page-layout>
